// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-wrapper[data-v-764e4a4c] {
  display: flex;
  flex-direction: column;
}
.content-wrapper p[data-v-764e4a4c] {
  margin: 0 0 1.5em;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/DelChatMessage.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".content-wrapper[data-v-764e4a4c] {\n  display: flex;\n  flex-direction: column;\n}\n.content-wrapper p[data-v-764e4a4c] {\n  margin: 0 0 1.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
